import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

import { MonedasConstant } from 'constants/index'

const MonedaFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [monedasOptions, setMonedasOptions] = React.useState([])

  React.useEffect(() => {
    setMonedasOptions(
      MonedasConstant.__array.map((x, k) => (
        <option key={k} value={x.id}>
          {x.nombre}
        </option>
      ))
    )
  }, [])

  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='select-moneda' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='moneda'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-moneda'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              {monedasOptions}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
